import { useMemo } from 'react'

import { Box, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { ChartData, ChartOptions } from 'chart.js'
import { Chart } from 'react-chartjs-2'

import {
  FULFILMENT_RING_SIZE,
  FULFILMENT_RING_TRACK_ALPHA,
} from 'components/reports/Metrics/constants/DriverAppFulfilment'

interface Props {
  percentage: number
  color: string
}

export const FulfilmentRingChart = ({ percentage, color }: Props) => {
  const value = Math.min(Math.max(percentage, 0), 100)

  const data = useMemo<ChartData<'doughnut', number[], string>>(
    () => ({
      datasets: [
        {
          data: [value, 100 - value],
          backgroundColor: [color, alpha(color, FULFILMENT_RING_TRACK_ALPHA)],
          borderWidth: 0,
          borderRadius: 4,
        },
      ],
    }),
    [value, color],
  )

  const options = useMemo<ChartOptions<'doughnut'>>(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      cutout: '78%',
      animation: false,
      events: [],
      plugins: { legend: { display: false }, tooltip: { enabled: false } },
    }),
    [],
  )

  return (
    <Box
      sx={{
        position: 'relative',
        width: FULFILMENT_RING_SIZE,
        height: FULFILMENT_RING_SIZE,
        flexShrink: 0,
      }}>
      <Chart<'doughnut', number[], string> type='doughnut' data={data} options={options} />
      <Typography
        variant='subtitle1'
        fontWeight={700}
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        {value.toFixed(1)}%
      </Typography>
    </Box>
  )
}
